<template>
<div>
    <form action="/">
      <van-search
        v-model="search"
        show-action
        clearable
        :placeholder="placeholder"
        @clear="onClear"
        @search="onSearch"
        @cancel="onCancel"
      />
    </form>
</div>
</template>

<script>
export default {
  props: {
    value: String,
    placeholder: {
      type: String,
      default: '请输入搜索关键词'
    }
  },
  model: {
    type: 'input'
  },
  data() {
    return {
      search: '',
    }
  },
  watch: {
    search(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    onClear() {
      this.$emit('input', '')
    },    
    onSearch(val) {
      this.$emit('search', val)
    },
    onCancel() {
      this.$emit('search', '')
    },
  }
}
</script>

<style>

</style>